import type { AsterionApp } from '@/types';

export const ASTERION_APPS: AsterionApp[] = [
  {
    id:          'report',
    name:        'Asterion Report',
    description: 'Inspection reports for machine shops — 95% of dimensions extracted straight from the drawing (OCR + AI, handwritten values included), ballooned drawings, GD&T per ASME Y14.5, non-conformity detection. 45 min → 7 min per report.',
    icon:        'FileText',
    logo:        'icon-asterion-report',
    logoFull:    'logo-asterion-report',
    colorVar:    'var(--color-anticiper)',
    colorRgbVar: 'var(--color-anticiper-rgb)',
    tag:         'AI · OCR · GD&T',
    screenshot:  '/asterion/shot-report.gif',
  },
  {
    id:          'qms',
    name:        'Asterion QMS',
    description: 'An ISO 9001:2015 quality system for manufacturing SMEs — NC/CAPA, risks scored P×G×D, audits, management review, competencies and suppliers. Never blocking: a deviation is logged in 30 seconds from a phone, then the information flows between modules with zero re-entry.',
    icon:        'FileCheck',
    logo:        'icon-asterion-qms',
    logoFull:    'logo-asterion-qms',
    colorVar:    'var(--color-ameliorer)',
    colorRgbVar: 'var(--color-ameliorer-rgb)',
    tag:         'ISO 9001 · NC/CAPA',
    screenshot:  '/asterion/shot-qms.jpg',
  },
  {
    id:          'gage',
    name:        'Asterion Gage',
    description: 'The measuring-instrument fleet under control — full registry, calibrations spread evenly across the year, alerts ahead of every due date, lab certificates attached automatically, colour-coded P-touch labels. ISO 17025 aligned, audit-ready exports.',
    icon:        'Ruler',
    logo:        'icon-asterion-gage',
    logoFull:    'logo-asterion-gage',
    colorVar:    'var(--color-gage)',
    colorRgbVar: 'var(--color-gage-rgb)',
    tag:         'ISO 17025 · Metrology',
    screenshot:  '/asterion/shot-gage.jpg',
  },
  {
    id:          'outflow',
    name:        'Asterion Outflow',
    description: 'Shipping and outbound logistics — delivery notes, packing lists, AI-generated USMCA customs declarations, delivery tracking.',
    icon:        'Truck',
    colorVar:    'var(--color-reagir)',
    colorRgbVar: 'var(--color-reagir-rgb)',
    tag:         'Shipping · USMCA · AI',
    isDraft:     true,
  },
  {
    id:          'kairos',
    name:        'Asterion Kairos',
    description: 'Industrial planning and scheduling — Gantt charts, scheduling, milestone tracking and coordination of manufacturing steps, shaped for shop-floor reality.',
    icon:        'GanttChart',
    logo:        'icon-asterion-kairos',
    logoFull:    'logo-asterion-kairos',
    screenshot:  '/asterion/shot-kairos.jpg',
    colorVar:    'var(--color-kairos)',
    colorRgbVar: 'var(--color-kairos-rgb)',
    tag:         'Gantt · Scheduling',
  },
  {
    id:          'praxis',
    name:        'Asterion Praxis',
    description: 'Deliverable quality packages for job shops — every contractual requirement becomes a traceable line, AI checks CoCs, mill tests and NDT reports under human validation, then assembles an ordered PDF package ready to send. No more payments held for a missing certificate.',
    icon:        'BookOpen',
    logo:        'icon-asterion-praxis',
    logoFull:    'logo-asterion-praxis',
    colorVar:    'var(--color-praxis)',
    colorRgbVar: 'var(--color-praxis-rgb)',
    tag:         'AI · Quality packages',
    isDraft:     true,
  },
  {
    id:          'kraken',
    name:        'Asterion Kraken',
    description: 'Management of large-scale annual shutdowns — interactive site map, field connectivity, SMS reporting, team communication streams, Gantt and Kanban.',
    icon:        'Anchor',
    colorVar:    'var(--color-ciel)',
    colorRgbVar: 'var(--color-ciel-rgb)',
    tag:         'Major shutdowns · Gantt · Kanban',
    isDraft:     true,
  },
];
